/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Finish_TitleInputs */

const en_us2_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All set`)
};

const pt_br2_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo pronto`)
};

const es_419_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo listo`)
};

const pt_pt2_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo pronto`)
};

const fr_fr2_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est prêt`)
};

const de_de2_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles bereit`)
};

const it_it2_intake_finish_title = /** @type {(inputs: Intake_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto pronto`)
};

/**
* | output |
* | --- |
* | "All set" |
*
* @param {Intake_Finish_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_finish_title = /** @type {((inputs?: Intake_Finish_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Finish_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_finish_title(inputs)
	if (locale === "es-419") return es_419_intake_finish_title(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_finish_title(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_finish_title(inputs)
	if (locale === "de-DE") return de_de2_intake_finish_title(inputs)
	if (locale === "it-IT") return it_it2_intake_finish_title(inputs)
	return en_us2_intake_finish_title(inputs)
});
export { intake_finish_title as "intake.finish_title" }